export type FeedItemCardVariant = "mine" | "driver" | "default";

export function useFeedItemCardVariant({
  mine,
  isFromDriver,
}: {
  mine: boolean;
  isFromDriver: boolean;
}): FeedItemCardVariant {
  if (mine) return "mine";
  if (isFromDriver) return "driver";
  return "default";
}
